import React, { Component } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { ProductConsumer } from '../context';
import PropTypes from 'prop-types';

export default class Product extends Component {
  render() {
    const {id, title, img, price, inCart} = this.props.product;

    return (
      <ProductWrapper>
        <div className="card">
          <ProductConsumer>
            {(value) => (
              <div className="img-container" onClick={() => value.handleDetail(id)}>
                <Link to="/details">
                  <img src={img} alt="product" className="product-img" />
                </Link>
                <button
                  className="cartBtn"
                  disabled={inCart ? true : false}
                  onClick={() => {
                    value.addToCart(id);
                    value.openModal(id);
                  }}>
                  {inCart?(<p className="cartBtn-disabled" disabled>In Cart</p>):(<p className="cartBtn-enabled">Add</p>)}
                </button>
              </div>
            )}
          </ProductConsumer>
          {/* card footer */}
          <div className="cardFooter">
            <p className="productTitle">{title}</p>
            <h5 className="productPrice">${price}</h5>
          </div>
        </div>
      </ProductWrapper>
    )
  }
}

Product.propTypes = {
  product: PropTypes.shape({
    id: PropTypes.number,
    img: PropTypes.string,
    title: PropTypes.string,
    price: PropTypes.number,
    inCart: PropTypes.bool,
  }).isRequired
}

const ProductWrapper = styled.div`
  width: 450px;
  .card {
    border-color: transparent;
    transition: all 0.3s linear;
  }

  .cardFooter {
    background: transparent;
    border-top: transparent;
    transition: all 0.3s linear;
  }
  &:hover {
    .card {
      border: 0.04rem solid rgba(0,0,0,0.2);
      box-shadow: 2px 2px 5px 0px rgba(0,0,0,0.2);
    }
    .cardFooter {
      background: rgba(247,247,247);
    }
  }
  .img-container {
    position: relative;
    overflow: hidden;
  }
  .product-img {
    transition: all 0.3s linear;
  }
  .img-container:hover .product-img {
    transform: scale(1.1);
  }

  .cartBtn {
    position: absolute;
    bottom: 0;
    right: 0;
    padding: 0.2rem 0.4rem;
    background-color: var(--lightBlue) !important;
    border: none;
    margin-bottom: 0px;
    color: var(--mainWhite) !important;
    font-weight: bold;
    font-size: 1.4rem;
    border-radius: 0.5rem 0 0 0;
    transform: translate(100%, 100%);
    transition: all 0.3s linear;
  }
  .img-container:hover .cartBtn {
    transform: translate(0, 0);
  }

  .cartBtn:hover {
    color: var(--mainBlue) !important;
    cursor: pointer;
  }
`;